<template>
  <div style="display: inline">
    <base-button
      class="notification"
      type="info"
      icon
      size="sm"
      @click="openSubscriptionModal"
    >
      <span class="btn-inner--icon">
        <i class="fas fa-bell"></i>
      </span>
    </base-button>
    <modal :show="showModal" modal-classes="modal-secondary text-left">
      <h2 class="text-center">
        {{ $t("NOTIFICATIONS.SUBSCRIBE_TO_NOTIFICATIONS") }}
      </h2>
      <div class="row">
        <div
          v-for="(event, key) in events"
          :key="key"
          class="col-12 row notification-event"
        >
          <base-checkbox v-model="subscriptionsModel[key]">
            {{ event }}
          </base-checkbox>
        </div>
      </div>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-elite black"
          @click="closeModal"
          :disabled="loading"
        >
          {{ $t("COMMON.CLOSE") }}
        </button>
        <button
          type="submit"
          class="btn ml-auto btn-elite save"
          @click="save"
          :disabled="loading"
        >
          <span v-if="loading" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("NOTIFICATIONS.SAVE") }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Option, Select } from "element-ui";

export default {
  name: "notification-subscription",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    objectType: {
      type: String,
      description: "Object type of the notification subscription",
    },
    objectId: {
      type: String,
      description: "Object id of the notification subscription",
    },
    events: {
      type: Object,
      description: "Object format {EVENT_VALUE: EVENT_NAME}",
    },
  },

  data() {
    return {
      subscribedEvents: [],
      subscriptionsModel: {},
      showModal: false,
      loading: false,
    };
  },

  setup() {},

  created() {},

  methods: {
    async openSubscriptionModal() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      let params = {
        sort: "event",
        filter: {
          object_type: this.objectType,
          object_id: this.objectId,
        },
        page: {
          number: 1,
          size: 999,
        },
        include: "",
      };
      try {
        await this.$store.dispatch("notificationSubscriptions/list", params);
        this.subscribedEvents =
          this.$store.getters["notificationSubscriptions/list"];
        for (const subscription of this.subscribedEvents) {
          this.subscriptionsModel[subscription.event] = true;
        }
        for (const event of Object.keys(this.events)) {
          if (!Object.keys(this.subscriptionsModel).includes(event)) {
            this.subscriptionsModel[event] = false;
          }
        }
        this.showModal = true;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      swal.close();
    },

    closeModal() {
      this.showModal = false;
    },

    async save() {
      this.loading = true;
      try {
        const eventsSubscriptions = [];
        for (const event of Object.keys(this.subscriptionsModel)) {
          if (this.subscriptionsModel[event]) {
            if (!this.subscribedEvents.find((item) => item.event === event)) {
              const subscriptionData = {
                type: "notification-subscriptions",
                event: event,
                object_type: this.objectType,
                object_id: this.objectId,
              };
              await this.$store.dispatch(
                "notificationSubscriptions/add",
                subscriptionData
              );
            }
            eventsSubscriptions.push(event);
          }
        }

        for (const subscription of this.subscribedEvents) {
          if (!eventsSubscriptions.includes(subscription.event)) {
            await this.$store.dispatch(
              "notificationSubscriptions/destroy",
              subscription.id
            );
          }
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }

      this.$notify({
        type: "success",
        message: this.$t("NOTIFICATIONS.SUBSCRIPTIONS_SAVED"),
      });
      this.loading = false;
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.base-button.notification {
  min-width: 56px;
  min-height: 48px;
  box-shadow: none;
  background-color: #280059;
  border: none;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  color: #fff;
  @media only screen and (max-width: 1200px) {
    min-width: 36px;
    min-height: 36px;
  }
  &:hover {
    transform: none;
    box-shadow: none;
  }
  .btn-inner--icon {
    line-height: 14px;
    i {
      font-size: 16px;
      color: #fff;
      @media only screen and (max-width: 1200px) {
        font-size: 14px;
      }
    }
  }
  &.btn-elite {
    width: auto;
    background-color: #ffeb00;
    color: #000;
  }
}

.modal {
  &-dialog {
    .modal-content {
      background-color: #fff;

      .modal-body {
        .row {
          margin: 0;
          .custom-checkbox .custom-control-label {
            margin: 5px 0;
            padding: 0 10px;
            font-size: 15px;
            &:before,
            &:after {
              left: -20px;
              top: 2px;
            }
          }
          .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #000;
          }
          .custom-control-input:checked ~ .custom-control-label::after {
            background-image: none;
            content: "\f00c";
            font-family: "Font Awesome\5 Pro";
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            color: var(--primary-color);
            top: 2px;
            left: -20px;
          }
        }
      }

      .modal-footer {
        border-top: solid 1px #e6e6e6;

        button {
          &.btn {
            margin: 0;
            &:hover {
              box-shadow: none;
              transform: none;
            }
            &.save {
              background-color: #2ba9e4;
              color: #fff;
            }
            &.black {
              background-color: #000;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.modal-body .notification-event .custom-control.custom-checkbox label {
  font-size: 1.1rem;
  margin: 20px 0px;
  font-weight: 550;
}
</style>
